import React from "react";
import {
    Headline,
    Loading,
    Text,
    useThemedStyle,
} from "@venuepos/react-common";
import { useTranslation } from "locales";
import { dashboardStyleFunc } from "../styles";
import { View } from "react-native";
import { CompareData } from "../merchant-dashboard";
import { useComparisonWidths } from "./use-comparison-widths";

export const InvoiceTotal = React.memo(function InvoiceTotalComponent({
    data,
    compareTo,
}: {
    data?: CompareData;
    compareTo?: CompareData;
}) {
    const [t] = useTranslation();
    const sharedStyles = useThemedStyle(dashboardStyleFunc);

    const { baseDataWidth, compareDataWidth, noData } = useComparisonWidths(
        data?.dashboard?.totals.invoices ?? 0,
        compareTo?.dashboard?.totals.invoices ?? 0,
        data?.date,
        compareTo?.date
    );

    return (
        <View>
            <Headline style={sharedStyles.totalHeadline} size="h5">
                {t(
                    "dashboard.widgets.number_of_transactions",
                    "Number of transactions"
                )}
            </Headline>
            <View>
                {!data ? (
                    <Loading message={t("common.loading", "Loading")} />
                ) : (
                    <>
                        <View style={sharedStyles.dataRow}>
                            {!compareTo ? (
                                <View style={sharedStyles.dataSingleValue}>
                                    <Text style={sharedStyles.totalValue}>
                                        {data.dashboard?.totals.invoices}
                                    </Text>
                                </View>
                            ) : (
                                <>
                                    <Text style={[sharedStyles.totalValue]}>
                                        {data.date}
                                    </Text>
                                    <Text style={sharedStyles.totalValue}>
                                        {data.dashboard?.totals.invoices}
                                    </Text>
                                </>
                            )}
                        </View>
                    </>
                )}
                {!compareTo ? null : (
                    <>
                        <View
                            style={[
                                sharedStyles.graphHolder,
                                noData ? sharedStyles.graphHolderEmpty : null,
                            ]}
                        >
                            {!noData ? (
                                <>
                                    <View
                                        style={[
                                            sharedStyles.defaultBar,
                                            baseDataWidth >= compareDataWidth
                                                ? sharedStyles.positiveBar
                                                : sharedStyles.negativeBar,
                                            {
                                                width: `${baseDataWidth}%`,
                                            },
                                        ]}
                                    />
                                    <View
                                        style={[
                                            sharedStyles.defaultBar,
                                            {
                                                width: `${compareDataWidth}%`,
                                            },
                                        ]}
                                    />
                                </>
                            ) : (
                                <Text style={sharedStyles.noDataText}>
                                    {t(
                                        "dashboard.no_data_plural",
                                        "No data for the selected dates"
                                    )}
                                </Text>
                            )}
                        </View>
                        <View style={sharedStyles.dataRow}>
                            <Text style={sharedStyles.compareValue}>
                                {compareTo?.date}
                            </Text>
                            <Text style={[sharedStyles.compareValue]}>
                                {compareTo.dashboard?.totals.invoices}
                            </Text>
                        </View>
                    </>
                )}
            </View>
        </View>
    );
});
